import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const IntroMuroCarbonDeBambu = () => {
  return (
    <section className="pb-lg-22">
      <div className="container">
        <div className="row align-items-center mt-n1-6 mt-sm-n6">
          <div className="col-lg-5 mt-1-6 mt-sm-6">
            <div className="position-relative text-center text-lg-start">
              <img 
                src="/assets/img/productos/muro-carbon-de-bambu/muro-carbon-de-bambu-intro.jpg" 
                alt="pisos spc en sala" 
              />
              <div className="position-absolute bottom-n10 right-n10 right-lg-n30 d-none d-sm-block">
                <img 
                  src="/assets/img/productos/muro-carbon-de-bambu/muro-carbon-de-bambu-intro-small.png" 
                  alt="..." 
                  style={{ width: '300px', height: '300px' }} 
                />
              </div>
            </div>
          </div>
          <div className="col-lg-7 mt-1-6 mt-sm-6">
            <div className="ps-lg-2-9 ps-xl-10">
              <div className="mb-1-9 mb-xl-8">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">Para interiores</span>
                <h2 className="mb-1-6 display-5 font-weight-800 lh-1">Panel Decorativo de Fibra de Carbón de Bambú</h2>
              </div>
              <div className="ps-1-9 ps-sm-10 ps-lg-20">
                <p className="mb-1-6 mb-sm-2-2">
                Los paneles de pared de chapa de madera con carbón de bambú se presentan en dos variantes: con acabado en un lado y sin acabado.<br></br><br></br>
                <b>Con acabado:</b> El tablero de espuma WPC con superficie acabada ofrece un aspecto suave y liso, logrando que la pared tenga un acabado elegante y refinado.<br></br>
                <b>Sin acabado:</b> Este estilo conserva la textura natural de la madera, brindando un aspecto más auténtico y rústico, con el encanto original de la madera.<br></br><br></br>
                Ambos estilos de panel cuentan con un tratamiento en su superficie que los hace impermeables, resistentes a la humedad, a prueba de insectos y fáciles de mantener. 
                Estas características los convierten en una opción ideal para decorar y proteger paredes interiores.
                </p>
                <a href="contacto-decototal" className="butn-style4 secondary"><span>Cotiza con nosotros</span></a>
                <BannerNoInstalacion />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroMuroCarbonDeBambu;